angular.module('calendarApp').directive('costModal', function () {
  return {
    restrict: 'AE',
    scope: {
      costs: '=?'
    },
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/cost-modal.html',
    link: function link(scope, elem, attrs) {
      scope.modalID = uuidv4();
      scope.currencySettings = smooth.currencySettings;

      var init = function init() {
        scope.viewMemberships = false;
        scope.hasNonMembershipOptions = !!(scope.costs.workshop || scope.costs.packages && scope.costs.packages.length || scope.costs.singleappointment);

        if (scope.costs.memberships && scope.costs.memberships.length) {
          scope.form = {
            selectedMembershipIndex: 0
          };
          scope.selectedMembership = scope.costs.memberships[0];
          scope.costs.memberships[0].selected = true;
          if (!scope.hasNonMembershipOptions) scope.viewMemberships = true;
        }
      };

      scope.chooseMembership = function () {
        scope.selectedMembership = scope.costs.memberships[scope.form.selectedMembershipIndex];
      };

      scope.showModal = function () {
        $("#".concat(scope.modalID)).modal();
        init();
      };

      scope.toggleViewMemberships = function () {
        scope.viewMemberships = !scope.viewMemberships;
      };

      function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
              v = c == 'x' ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });
      }
    }
  };
}); // End directive